<template>
  <div id="logs">
    <template v-if="list">
      <el-table
        v-loading="loading"
        :header-cell-style="getRowClass"
        :data="list"
        border
        style="width: 100%"
      >
        <!-- 显示产品 购买人  状态  订单号 快递公司 ~ 快递单号 【查看物流】 -->
        <!-- <el-table-column prop="time" label="下单时间" width="150"> </el-table-column> -->

        <el-table-column
          prop="title"
          :show-overflow-tooltip="true"
          label="产品标题"
        >
        </el-table-column>

        <el-table-column prop="zhuangtai" label="客户信息" width="200">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              title="详细信息"
              width="200"
              trigger="hover"
              :content="scope.row.info"
            >
              <span class="info" slot="reference">{{ scope.row.info }}</span>
            </el-popover>

            <!-- <span>地址:{{scope.row.address_info.province_name+scope.row.address_info.city_name+scope.row.address_info.county_name+scope.row.address_info.detail_info}}</span> -->
          </template>
        </el-table-column>

        <el-table-column prop="zhuangtai" label="订单状态" width="90">
        </el-table-column>

        <el-table-column prop="order_id" label="订单号" width="160">
        </el-table-column>

        <el-table-column prop="delivery_name" label="快递公司" width="90">
        </el-table-column>

        <el-table-column prop="zhuangtai" label="操作" width="120">
          <template slot-scope="scope">
            <el-button v-if='scope.row.zhuangtai=="申请代发"'
              size="small"
             
              @click="ship(scope.row.order_id)"
              type="primary"
              >立即发货</el-button
            >
             <el-button v-else-if='scope.row.zhuangtai=="已发货"'
              size="small"
             
              @click="money(scope.row.order_id,scope.row.fromshopid)"
              type="primary"
              >申请结算</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <el-pagination
          background
          v-loading="loading"
          layout="prev, pager, next"
          :total="total"
          :current-page="page"
          :page-size="20"
          @current-change="change"
        >
        </el-pagination>
      </div>

      <el-drawer
        title="立即发货"
        :visible.sync="drawer"
        :size='$store.state.isMobile ? "100%" :"40%"'
        :direction="direction"
        :before-close="handleClose"
      >
        <div class="wuliu">
            <el-select v-model="kdval" placeholder="请选择快递公司">
              <el-option
                v-for="item in kdList"
                :key="item.id"
                :label="item.delivery_name"
                :value="item.delivery_id">
              </el-option>
            </el-select>
            <el-input
              placeholder="请输入单号"
              v-model="input"
              clearable>
            </el-input>

            <el-button type="primary" class="btn" @click="addwl">提交信息</el-button>

        </div>
      </el-drawer>
    </template>
  </div>
</template>
<style lang="scss">
.wuliu {
  width: 70%;
  height: 80%;
  box-sizing: border-box;
  padding: 30px;
  overflow-y: scroll;
  margin: 0 auto;
  .el-select{
    width: 100%;
    margin-bottom: 30px;

  }
  .btn{
    margin: 30px auto;
    display: block;
  }
}
.info{

overflow:hidden; //超出的文本隐藏
text-overflow:ellipsis; //溢出用省略号显示
white-space:nowrap; //溢出不换行
}
</style>
<script>
export default {
  name: "supplier",
  data() {
    return {
      list: [],
      loading: true,
      page: 1,
      total: 0,
      drawer: false,
      direction: "rtl",
      wlData: [],
      reverse: true,
      kdList:[],
      kdval:"",
      input:"",
      order_id:"",
    };
  },
  methods: {
    // 列表
    getList() {
      this.loading = true;
      this.axios
        .get(this.api.gylist, {
          params: {
            page: this.page
          }
        })
        .then(res => {
          this.loading = false;
          this.total = Number(res.count);
          if (res.data != "") {
            res.data.forEach(element => {
              element.time = this.getDate(element.addtime);

              element.info =
                "姓名：" +
                element.address_info.user_name +
                "  手机号：" +
                element.address_info.tel_number +
                "  地址：" +
                element.address_info.province_name +
                element.address_info.city_name +
                element.address_info.county_name +
                element.address_info.detail_info;
            });
            this.list = [...this.list, ...res.data];
          }
        });
    },
    //分页
    change(val) {
      this.page = val;
      this.getList();
    },
    // 快递列表
    kuaidi(){
        this.axios.get(this.api.kuaidi)
        .then((res)=>{
            this.kdList=res;
        })
    },
    // 转化年月日
    getDate(time) {
      var date = new Date(Number(time * 1000));
      let Y = date.getFullYear() + "-",
        M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-",
        D = date.getDate() + " ",
        h = date.getHours() + ":",
        m = date.getMinutes();
      // s = date.getSeconds();
      return Y + M + D + h + m;
    },
    //列表样式
    getRowClass({ row, column, rowIndex }) {
      console.log(row, column);
      if (rowIndex === 0) {
        return "background:#F5F7FA;color:#353535;";
      } else {
        return "";
      }
    },

    wuliu(id) {
      console.log(id);
      this.axios
        .get(this.api.wuliu, {
          params: {
            sku: id
          }
        })
        .then(res => {
          res.data.list.forEach(item => {
            item.timestamp = this.getDate(Number(item.time));
          });
          this.wlData = res.data.list;
          this.drawer = true;
        });
      // wuliu
    },
    // 关闭右侧
    handleClose(done) {
      this.wlData = [];
      done();
    },
    //立即发货
    ship(id){
      this.drawer = true;
      this.order_id=id;
    },
    //提交物流
    addwl(){
      if(this.kdval!=''&&this.val!=''){
        this.axios.get(this.api.addwl,{
          params:{
            delivery_id:this.kdval,
            waybill_id:this.input,
            order_id:this.order_id
          }
        })
        .then((res)=>{
          console.log(res)
          if(res.code==1){
             this.$message({
                message: res.msg,
                type: 'success'
              });
          }else{
             this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
      }
    },
    //申请结算
    money(id,shopid){
     
    
      this.axios.get(this.api.jiesuan,{
        params:{
          order_id:id,
          shopid:shopid
        }
      })
      .then((res)=>{
        
         this.$message({
              message: res.msg,
              type: 'warning'
          });
          this.page=1;
          this.list=[];
          let timer=setTimeout(()=>{
            clearTimeout(timer)
            this.getList();
          },1000)
        
      })
    },
  },
  created() {
    this.getList();
    this.kuaidi()
  }
};
</script>